import Box from '@mui/material/Box'

import Text from '../text/Text'
import FaIcon from '../faIcon/FaIcon'

// ----------------------------------------------------------------------

export function FormHead({ sx, icon, title, description, ...other }) {
  return (
    <>
      {icon && (
        <Box
          component='span'
          sx={{ mb: 3, mx: 'auto', display: 'inline-flex' }}
        >
          <FaIcon icon={icon} size='lg' />
        </Box>
      )}

      <Box
        sx={[
          () => ({
            mb: 5,
            gap: 1.5,
            display: 'flex',
            textAlign: 'center',
            whiteSpace: 'pre-line',
            flexDirection: 'column'
          }),
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
        {...other}
      >
        <Text variant='h5' label={title} color='' />
        {description && (
          <Text
            variant='body2'
            sx={{ color: 'text.secondary' }}
            label={description}
          />
        )}
      </Box>
    </>
  )
}
